export default __webpack_public_path__ + "static/media/alarm.864f298a.svg";